/* Hero.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"],
  _excluded6 = ["as", "style"],
  _excluded7 = ["as", "style"],
  _excluded8 = ["as", "style"],
  _excluded9 = ["as", "style"],
  _excluded10 = ["as", "style"],
  _excluded11 = ["as", "style"],
  _excluded12 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _53 = "@media (min-width:64rem){._10jx1ccs{max-width:35rem}}";
const _52 = "@media (min-width:64rem){._3p1cv47k{font-size:var(--ds-space-250,20px)}}";
const _51 = "._otyrxy5q{margin-bottom:var(--ds-space-400,2pc)}";
const _50 = "._1wyb1cby{font-size:1.125rem}";
const _49 = "._k48p1nn1{font-weight:400}";
const _48 = "._ect41roz{font-family:var(--ds-font-family-brand-heading,\"Charlie Display\",ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const _47 = "._1ygb1a9f:focus-visible{outline:var(--_1kmg6zk)}";
const _46 = "._y3gn1h6o{text-align:center}";
const _45 = "._k48p1fw0{font-weight:700}";
const _44 = "@media (min-width:64rem){._isu4xncg{margin-bottom:var(--ds-space-800,4pc)}}";
const _43 = "@media not all and (min-width:64rem){._1s4p1osq{width:100%}._sp8t1jfw{padding-left:var(--ds-space-500,40px)}._axwi1jfw{padding-right:var(--ds-space-500,40px)}}";
const _42 = "@media not all and (min-width:48rem){._1rfm1osq{width:100%}._1mae1ejb{padding-left:var(--ds-space-300,24px)}._1ggm1ejb{padding-right:var(--ds-space-300,24px)}}";
const _41 = "._1bah1h6o{justify-content:center}";
const _40 = "._zulpxy5q{gap:var(--ds-space-400,2pc)}";
const _39 = "@keyframes fadeIn{0%{opacity:0}to{opacity:1}}";
const _38 = "._tzy4idpf{opacity:0}";
const _37 = "._y44v17nv{animation:fadeIn .5s ease-in-out forwards}";
const _36 = "@media not all and (min-width:90rem){._zzrme2i8{width:23.375rem}}";
const _35 = "._1bsba8ze{width:27.5rem}";
const _34 = "@media (min-width:48rem) and (max-width:63.99rem){._1gzv1jfw{gap:var(--ds-space-500,40px)}._1m491h6o{justify-content:center}._i6jx1jfw{padding-top:var(--ds-space-500,40px)}._kon51bp4._kon51bp4{flex-direction:column}}";
const _33 = "@media not all and (min-width:48rem){._8164xy5q{gap:var(--ds-space-400,2pc)}._nssp1h6o{justify-content:center}._1kmx1ejb{padding-top:var(--ds-space-300,24px)}._1s5v1bp4._1s5v1bp4{flex-direction:column}}";
const _32 = "._1bah1yb4{justify-content:space-between}";
const _31 = "._2lx2vrvc{flex-direction:row}";
const _30 = "._1wpz1fhb{align-self:stretch}";
const _29 = "._ca0qpxbi{padding-top:var(--ds-space-200,1pc)}";
const _28 = "._otyru2gc{margin-bottom:var(--ds-space-100,8px)}";
const _27 = "._94n51df4{bottom:-.3rem}";
const _26 = "._1xi2idpf{right:0}";
const _25 = "._1ltvidpf{left:0}";
const _24 = "._154iidpf{top:0}";
const _23 = "._kqswstnw{position:absolute}";
const _22 = "._4t3i1wug{height:auto}";
const _21 = "@media (min-width:48rem){._6o24cs5v{order:2}._14b51ssb{width:50%}}";
const _20 = "._1f49kb7n{order:1}";
const _19 = "@media (min-width:48rem) and (max-width:63.99rem){._lg5rxy5q{margin-top:var(--ds-space-400,2pc)}}";
const _18 = "._19pk1ejb{margin-top:var(--ds-space-300,24px)}";
const _17 = "@media (min-width:48rem){._6o24kb7n{order:1}._14b51ssb{width:50%}}";
const _16 = "._1f49cs5v{order:2}";
const _15 = "._135a1h6o{justifycontent:center}";
const _14 = "@media (min-width:48rem){._19wgxy5q{gap:var(--ds-space-400,2pc)}._1xlo1osq{height:100%}._1lp7vrvc{flex-direction:row}}";
const _13 = "._2lx21bp4{flex-direction:column}";
const _12 = "._4cvr1h6o{align-items:center}";
const _11 = "._1e0c1txw{display:flex}";
const _10 = "._zulp1ejb{gap:var(--ds-space-300,24px)}";
const _9 = "._1ygbugt7:focus-visible{outline:2px solid var(--ds-border-focused,#388bff)}";
const _8 = "._syaz15cr{color:var(--ds-text-inverse,#fff)}";
const _7 = "._otyrpxbi{margin-bottom:var(--ds-space-200,1pc)}";
const _6 = "._19pkidpf{margin-top:0}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { xcss } from '@atlaskit/primitives';
import { Hide, media, Show } from '@atlaskit/primitives/responsive';
import { ACTION_SUBJECT_ID_SLIDE, CarouselClickEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { useStatsig } from '@atlassian/mpac-feature-flags';
import { BodyLarge, BodyNormal, Breadcrumbs, BreadcrumbsItem, CurvedButton, FluidContainer, H1, useMediumScreen } from '@atlassian/mpac-primitives';
import { SearchEmbedded } from '@atlassian/mpac-search';
import { useHistory } from '@atlassian/mpac-ui';
import React, { useCallback, useMemo } from 'react';
import { Hero3ColumnLayout } from './Hero3ColumnLayout';
import { HeroFullImage } from './HeroFullImage';
import { HeroSpotlightWithRightImage } from './HeroSpotlightWithRightImage';
import HeroImage from '../../assets/hero.svg';
import HeroTopLeftVisual from '../../assets/hero-left-top-visual.svg';
import HeroBottomRightVisual from '../../assets/hero-right-bottom-visual.svg';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _5 = "@media (min-width:30rem){._1wbfltin{padding:var(--ds-space-500,40px) 0 var(--ds-space-800,4pc) 0}}";
const _4 = "._1bsb1osq{width:100%}";
const _3 = "._kqswh2mm{position:relative}";
const _2 = "._11q7sc1o{background:var(--ds-text-accent-blue-bolder,#09326c)}";
const _ = "._1yt41tj2{padding:var(--ds-space-400,2pc) 0 var(--ds-space-500,40px) 0}";
const HeroWrapper = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1yt41tj2 _11q7sc1o _kqswh2mm _1bsb1osq _1wbfltin", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  HeroWrapper.displayName = 'HeroWrapper';
}
const Heading = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = H1,
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_6, _7, _8, _9]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pkidpf _otyrpxbi _syaz15cr _1ygbugt7", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Heading.displayName = 'Heading';
}
const Description = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = BodyLarge,
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_8, _6]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_syaz15cr _19pkidpf", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Description.displayName = 'Description';
}
const Search = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = SearchEmbedded,
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_4]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1bsb1osq", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Search.displayName = 'Search';
}
const HeroInner = forwardRef((_ref5, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_10, _11, _12, _13, _14]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_zulp1ejb _1e0c1txw _4cvr1h6o _2lx21bp4 _19wgxy5q _1xlo1osq _1lp7vrvc", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  HeroInner.displayName = 'HeroInner';
}
const HeroInnerStyle = null;
const ProductHeroInnerStyle = null;
const HeroWrapperStyle = null;
const BreadcrumbContainerStyle = null;
const HeroWrapperBodyStyle = null;
const ContentSearchContainerStyle = null;
const HeadingStyle = null;
const DescriptionStyle = null;
const SearchWrapperStyle = null;
const fadeInAnimation = null;
const HeroImageStyle = null;
const HeroImageDesktopContainerStyle = null;
const HeroImageDesktopStyle = null;
const HeroImageContainerStyle = xcss({
  width: '100%',
  height: 'auto',
  objectFit: 'contain'
});
const ContentSearchContainer = forwardRef((_ref6, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref6,
    __cmplp = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_11, _4, _13, _15, _16, _17]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _1bsb1osq _2lx21bp4 _135a1h6o _1f49cs5v _6o24kb7n _14b51ssb", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ContentSearchContainer.displayName = 'ContentSearchContainer';
}
const SearchWrapper = forwardRef((_ref7, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref7,
    __cmplp = _objectWithoutProperties(_ref7, _excluded7);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_4, _18, _19]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1bsb1osq _19pk1ejb _lg5rxy5q", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  SearchWrapper.displayName = 'SearchWrapper';
}
const ImageContainer = forwardRef((_ref8, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref8,
    __cmplp = _objectWithoutProperties(_ref8, _excluded8);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_4, _20, _21]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1bsb1osq _1f49kb7n _6o24cs5v _14b51ssb", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ImageContainer.displayName = 'ImageContainer';
}
const Image = forwardRef((_ref9, __cmplr) => {
  let {
      as: C = "img",
      style: __cmpls
    } = _ref9,
    __cmplp = _objectWithoutProperties(_ref9, _excluded9);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_4, _22]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1bsb1osq _4t3i1wug", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Image.displayName = 'Image';
}
const HeroTopLeftImage = forwardRef((_ref10, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref10,
    __cmplp = _objectWithoutProperties(_ref10, _excluded10);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_23, _24, _25]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_kqswstnw _154iidpf _1ltvidpf", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  HeroTopLeftImage.displayName = 'HeroTopLeftImage';
}
const HeroBottomRightImage = forwardRef((_ref11, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref11,
    __cmplp = _objectWithoutProperties(_ref11, _excluded11);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_23, _26, _27]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_kqswstnw _1xi2idpf _94n51df4", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  HeroBottomRightImage.displayName = 'HeroBottomRightImage';
}
const BreadcrumbContainer = forwardRef((_ref12, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref12,
    __cmplp = _objectWithoutProperties(_ref12, _excluded12);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_28]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_otyru2gc", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  BreadcrumbContainer.displayName = 'BreadcrumbContainer';
}
export const BANNER_TYPE = {
  HERO_3_COLUMN_LAYOUT: 'HERO_3_COLUMN_LAYOUT',
  HERO_FULL_IMAGE: 'HERO_FULL_IMAGE',
  SPOTLIGHT_WITH_RIGHT_IMAGE: 'SPOTLIGHT_WITH_RIGHT_IMAGE'
};

// eslint-disable-next-line max-lines-per-function, complexity
export const Hero = _ref13 => {
  let {
    heading,
    description,
    breadcrumbTitle,
    productIdForAlgolia,
    productName,
    heroDesktopLeftImage,
    heroDesktopRightImage,
    heroTabletImage,
    heroMobileImage,
    isSearchBarIncluded = true,
    heroDesktopImage,
    type,
    redirectUrl,
    index,
    eyebrowText,
    ctaText,
    buttonLabel,
    buttonHref,
    headingStyles,
    buttonAriaLabel,
    buttonDataTestId,
    onCTAClick
  } = _ref13;
  const history = useHistory();
  const showBelowMedium = useMediumScreen();
  const {
    enableMpacWebCoherence,
    enableMpacConfigurator,
    enableHomepageSpotlight
  } = useStatsig();
  const fireEvent = useAnalyticsEvents();
  const setFocusOnHeading = useCallback(ref => {
    if ((history === null || history === void 0 ? void 0 : history.action) === 'PUSH' && ref) setTimeout(() => ref === null || ref === void 0 ? void 0 : ref.focus());
  }, [history === null || history === void 0 ? void 0 : history.location]);
  const handleBreadcrumbsClick = event => {
    event.preventDefault();
    history === null || history === void 0 ? void 0 : history.push('/');
  };
  const handleBannerAction = useCallback(url => {
    fireEvent({
      eventType: CarouselClickEvent,
      actionSubjectId: ACTION_SUBJECT_ID_SLIDE,
      attributes: {
        url,
        type,
        position: index
      }
    });
    history === null || history === void 0 ? void 0 : history.push(url);
  }, [fireEvent, type, index, history]);
  const handleBannerClick = useCallback((event, url) => {
    event.preventDefault();
    handleBannerAction(url);
  }, [handleBannerAction]);
  const handleKeyDownBanner = useCallback((event, url) => {
    if (event.key === 'Enter' || event.code === 'NumpadEnter') {
      event.preventDefault();
      handleBannerAction(url);
    }
  }, [handleBannerAction]);
  const searchPlaceholder = productName ? {
    mobile: "Search apps for ".concat(productName),
    desktop: "Search apps for ".concat(productName, " within Marketplace")
  } : undefined;
  const additionalQueryParams = useMemo(() => {
    return productIdForAlgolia ? {
      product: productIdForAlgolia
    } : undefined;
  }, [productIdForAlgolia]);
  const HeroButton = () => {
    return buttonLabel && buttonHref ? /*#__PURE__*/_jsx(CurvedButton, {
      href: buttonHref,
      onClick: onCTAClick,
      "aria-label": buttonAriaLabel,
      "data-testid": buttonDataTestId,
      children: buttonLabel
    }) : null;
  };
  const getHeroContent = () => {
    switch (type) {
      case BANNER_TYPE.HERO_FULL_IMAGE:
        return /*#__PURE__*/_jsx(HeroFullImage, {
          heroDesktopImage: heroDesktopImage,
          heroTabletImage: heroTabletImage,
          heroMobileImage: heroMobileImage,
          redirectUrl: redirectUrl,
          onBannerClick: handleBannerClick,
          onKeyDownBanner: handleKeyDownBanner
        });
      case BANNER_TYPE.SPOTLIGHT_WITH_RIGHT_IMAGE:
        return /*#__PURE__*/_jsx(HeroSpotlightWithRightImage, {
          eyebrowText: eyebrowText,
          heading: heading,
          subHeading: description,
          ctaText: ctaText,
          heroDesktopImage: heroDesktopImage,
          heroTabletImage: heroTabletImage,
          heroMobileImage: heroMobileImage,
          redirectUrl: redirectUrl,
          onBannerClick: handleBannerClick,
          onKeyDownBanner: handleKeyDownBanner
        });
      case BANNER_TYPE.HERO_3_COLUMN_LAYOUT:
      default:
        return /*#__PURE__*/_jsx(Hero3ColumnLayout, {
          heading: heading,
          description: description,
          isSearchBarIncluded: isSearchBarIncluded,
          heroDesktopLeftImage: heroDesktopLeftImage,
          heroDesktopRightImage: heroDesktopRightImage,
          heroTabletImage: heroTabletImage,
          heroMobileImage: heroMobileImage,
          additionalQueryParams: additionalQueryParams,
          searchPlaceholder: searchPlaceholder,
          productName: productName,
          setFocusOnHeading: setFocusOnHeading,
          redirectUrl: redirectUrl,
          onBannerClick: handleBannerClick,
          onKeyDownBanner: handleKeyDownBanner,
          headingStyles: headingStyles,
          heroButton: HeroButton
        });
    }
  };
  if (enableMpacWebCoherence()) {
    return /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_11, _13, _4]
      }), /*#__PURE__*/_jsxs("div", {
        className: ax(["_1e0c1txw _2lx21bp4 _1bsb1osq"]),
        children: [/*#__PURE__*/_jsx(FluidContainer, {
          children: breadcrumbTitle && /*#__PURE__*/_jsxs(CC, {
            children: [/*#__PURE__*/_jsx(CS, {
              children: [_29]
            }), /*#__PURE__*/_jsx(BreadcrumbContainer, {
              className: ax(["_ca0qpxbi"]),
              children: /*#__PURE__*/_jsxs(Breadcrumbs, {
                children: [/*#__PURE__*/_jsx(BreadcrumbsItem, {
                  href: "/",
                  text: "Marketplace",
                  onClick: handleBreadcrumbsClick
                }), /*#__PURE__*/_jsx(BreadcrumbsItem, {
                  text: breadcrumbTitle,
                  onClick: event => event.preventDefault()
                })]
              })
            })]
          })
        }), enableMpacConfigurator() || enableHomepageSpotlight() ? getHeroContent() : /*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_11, _12, _30, _31, _32, _4, _33, _34]
          }), /*#__PURE__*/_jsxs("div", {
            className: ax(["_1e0c1txw _4cvr1h6o _1wpz1fhb _2lx2vrvc _1bah1yb4 _1bsb1osq _8164xy5q _nssp1h6o _1kmx1ejb _1s5v1bp4 _1gzv1jfw _1m491h6o _i6jx1jfw _kon51bp4"]),
            children: [/*#__PURE__*/_jsx(Hide, {
              below: "md",
              children: /*#__PURE__*/_jsxs(CC, {
                children: [/*#__PURE__*/_jsx(CS, {
                  children: [_35, _36]
                }), /*#__PURE__*/_jsx("div", {
                  className: ax(["_1bsba8ze _zzrme2i8"]),
                  children: /*#__PURE__*/_jsxs(CC, {
                    children: [/*#__PURE__*/_jsx(CS, {
                      children: [_37, _38, _4, _39]
                    }), /*#__PURE__*/_jsx("img", {
                      alt: "",
                      src: heroDesktopLeftImage,
                      className: ax(["_y44v17nv _tzy4idpf _1bsb1osq"])
                    })]
                  })
                })]
              })
            }), /*#__PURE__*/_jsxs(CC, {
              children: [/*#__PURE__*/_jsx(CS, {
                children: [_40, _11, _12, _41, _30, _42, _43]
              }), /*#__PURE__*/_jsx("div", {
                className: ax(["_zulpxy5q _1e0c1txw _4cvr1h6o _1bah1h6o _1wpz1fhb _1rfm1osq _1mae1ejb _1ggm1ejb _1s4p1osq _sp8t1jfw _axwi1jfw"]),
                children: /*#__PURE__*/_jsxs(CC, {
                  children: [/*#__PURE__*/_jsx(CS, {
                    children: [_11, _4, _41, _13, _12, _44]
                  }), /*#__PURE__*/_jsxs("div", {
                    className: ax(["_1e0c1txw _1bsb1osq _1bah1h6o _2lx21bp4 _4cvr1h6o", productName && "_isu4xncg"]),
                    children: [/*#__PURE__*/_jsxs(CC, {
                      children: [/*#__PURE__*/_jsx(CS, {
                        children: [_28, _45, _46, _4, _30, _47]
                      }), /*#__PURE__*/_jsx(H1, {
                        tabIndex: -1,
                        ref: setFocusOnHeading,
                        className: ax(["_otyru2gc _k48p1fw0 _y3gn1h6o _1bsb1osq _1wpz1fhb _1ygb1a9f"]),
                        style: _objectSpread(_objectSpread({}, headingStyles), {}, {
                          "--_1kmg6zk": ix("var(--ds-space-025, 2px)".concat(" solid ", "var(--ds-border-focused, #388BFF)"))
                        }),
                        children: heading
                      })]
                    }), description && /*#__PURE__*/_jsxs(CC, {
                      children: [/*#__PURE__*/_jsx(CS, {
                        children: [_6, _46, _30, _48, _49, _50, _4, _51, _52]
                      }), /*#__PURE__*/_jsx(BodyNormal, {
                        className: ax(["_19pkidpf _y3gn1h6o _1wpz1fhb _ect41roz _k48p1nn1 _1wyb1cby _1bsb1osq _otyrxy5q _3p1cv47k"]),
                        children: description
                      })]
                    }), isSearchBarIncluded && /*#__PURE__*/_jsxs(CC, {
                      children: [/*#__PURE__*/_jsx(CS, {
                        children: [_4, _53]
                      }), /*#__PURE__*/_jsx("div", {
                        className: ax(["_1bsb1osq _10jx1ccs"]),
                        children: /*#__PURE__*/_jsx(Search, {
                          additionalQueryParams: additionalQueryParams,
                          searchPlaceholder: searchPlaceholder
                        })
                      })]
                    }), /*#__PURE__*/_jsx(HeroButton, {})]
                  })]
                })
              })]
            }), /*#__PURE__*/_jsx(Hide, {
              below: "md",
              children: /*#__PURE__*/_jsxs(CC, {
                children: [/*#__PURE__*/_jsx(CS, {
                  children: [_35, _36]
                }), /*#__PURE__*/_jsx("div", {
                  className: ax(["_1bsba8ze _zzrme2i8"]),
                  children: /*#__PURE__*/_jsxs(CC, {
                    children: [/*#__PURE__*/_jsx(CS, {
                      children: [_37, _38, _4, _39]
                    }), /*#__PURE__*/_jsx("img", {
                      alt: "",
                      src: heroDesktopRightImage,
                      className: ax(["_y44v17nv _tzy4idpf _1bsb1osq"])
                    })]
                  })
                })]
              })
            }), /*#__PURE__*/_jsxs(Show, {
              xcss: HeroImageContainerStyle,
              below: "md",
              children: [/*#__PURE__*/_jsx(Hide, {
                below: "xs",
                children: /*#__PURE__*/_jsxs(CC, {
                  children: [/*#__PURE__*/_jsx(CS, {
                    children: [_37, _4, _38, _39]
                  }), /*#__PURE__*/_jsx("img", {
                    alt: "",
                    src: heroTabletImage,
                    className: ax(["_y44v17nv _1bsb1osq _tzy4idpf"])
                  })]
                })
              }), /*#__PURE__*/_jsx(Show, {
                xcss: HeroImageContainerStyle,
                below: "xs",
                children: /*#__PURE__*/_jsxs(CC, {
                  children: [/*#__PURE__*/_jsx(CS, {
                    children: [_37, _4, _38, _39]
                  }), /*#__PURE__*/_jsx("img", {
                    alt: "",
                    src: heroMobileImage,
                    className: ax(["_y44v17nv _1bsb1osq _tzy4idpf"])
                  })]
                })
              })]
            })]
          })]
        })]
      })]
    });
  }
  return /*#__PURE__*/_jsxs(HeroWrapper, {
    children: [/*#__PURE__*/_jsx(Hide, {
      below: "lg",
      children: /*#__PURE__*/_jsx(HeroTopLeftImage, {
        children: /*#__PURE__*/_jsx(Image, {
          alt: "",
          src: HeroTopLeftVisual
        })
      })
    }), /*#__PURE__*/_jsxs(FluidContainer, {
      children: [breadcrumbTitle && /*#__PURE__*/_jsx(BreadcrumbContainer, {
        children: /*#__PURE__*/_jsxs(Breadcrumbs, {
          textColor: "var(--ds-text-inverse, #FFFFFF)",
          children: [/*#__PURE__*/_jsx(BreadcrumbsItem, {
            href: "/",
            text: "Marketplace",
            onClick: handleBreadcrumbsClick
          }), /*#__PURE__*/_jsx(BreadcrumbsItem, {
            text: breadcrumbTitle,
            onClick: event => event.preventDefault()
          })]
        })
      }), /*#__PURE__*/_jsxs(HeroInner, {
        children: [/*#__PURE__*/_jsxs(ContentSearchContainer, {
          children: [/*#__PURE__*/_jsx(Heading, {
            tabIndex: -1,
            ref: setFocusOnHeading,
            children: heading
          }), /*#__PURE__*/_jsx(Description, {
            children: description
          }), !showBelowMedium && /*#__PURE__*/_jsx(SearchWrapper, {
            children: /*#__PURE__*/_jsx(Search, {
              additionalQueryParams: additionalQueryParams,
              searchPlaceholder: searchPlaceholder
            })
          })]
        }), /*#__PURE__*/_jsx(ImageContainer, {
          children: /*#__PURE__*/_jsx(Image, {
            alt: "",
            src: HeroImage,
            width: 752,
            height: 398
          })
        })]
      }), showBelowMedium && /*#__PURE__*/_jsx(SearchWrapper, {
        children: /*#__PURE__*/_jsx(Search, {
          additionalQueryParams: additionalQueryParams,
          searchPlaceholder: searchPlaceholder
        })
      })]
    }), /*#__PURE__*/_jsx(Hide, {
      below: "lg",
      children: /*#__PURE__*/_jsx(HeroBottomRightImage, {
        children: /*#__PURE__*/_jsx(Image, {
          alt: "",
          src: HeroBottomRightVisual
        })
      })
    })]
  });
};